import { GET, POST, POST_FILES } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return endpoint ? `/campaign-codes/${endpoint}` : '/campaign-codes';
};

// POST /v1.0/app/campaign-codes/upload
// multipart/form-data, field name "uploadFile" - handled by POST_FILES.
// Requires ROLE_THYAGA_ADMINISTRATOR.
export const uploadCampaignCodesSheet = (uploadedFile, token) => {
  const endpoint = getEndpointWithPrefix('upload');
  return POST_FILES(endpoint, uploadedFile, token);
};

// GET /v1.0/app/campaign-codes
// Plain paginated list, newest first. Requires ROLE_THYAGA_ADMINISTRATOR.
export const getCampaignCodes = (token, page = 0, size = 25) => {
  const endpoint = `${getEndpointWithPrefix()}?page=${page}&size=${size}`;
  return GET(endpoint, token);
};

// GET /v1.0/app/campaign-codes/search
// All filters are optional and combinable - partial/case-insensitive except
// `status`, which must be an exact AVAILABLE|ASSIGNED match.
// Requires ROLE_THYAGA_ADMINISTRATOR.
export const searchCampaignCodes = (token, filters = {}, page = 0, size = 25) => {
  const {
    secretCode,
    status,
    giftAllocation,
    territoryManager,
    customer,
    customerName,
    uniqueRef,
  } = filters;

  const params = new URLSearchParams();
  if (secretCode) params.append('secretCode', secretCode);
  if (status) params.append('status', status);
  if (giftAllocation) params.append('giftAllocation', giftAllocation);
  if (territoryManager) params.append('territoryManager', territoryManager);
  if (customer) params.append('customer', customer);
  if (customerName) params.append('customerName', customerName);
  if (uniqueRef) params.append('uniqueRef', uniqueRef);
  params.append('page', page);
  params.append('size', size);

  const endpoint = `${getEndpointWithPrefix('search')}?${params.toString()}`;
  return GET(endpoint, token);
};

// POST /v1.0/app/campaign-codes/csv
// Downloads a CSV export. ids/status/startDate/endDate are all optional -
// pass null for any filter that shouldn't narrow the export.
// Requires ROLE_THYAGA_ADMINISTRATOR.
export const downloadCampaignCodesCSV = (payload, token) => {
  const endpoint = getEndpointWithPrefix('csv');
  return POST(endpoint, payload, token);
};
